import React, { Component } from 'react';
import $ from 'jquery';
import { ToastContainer, toast } from "react-toastify";
import DataTable from 'react-data-table-component';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import { tokenVerification } from './Utils';
import "react-datepicker/dist/react-datepicker.css";
import DatePicker from "react-datepicker";

class ScheduleMileStone extends Component {
    constructor(props) {
        super(props);

        this.state = {
            startLoader: false,
            healthSystemId: '',
            hospitalId: '',
            serviceLineId: '',
            value: [],
            procedureData: '',
            loadedData: [],
            disableAddButton: false,
            editedId: '-1',
            editImageSrc: './assets/images/edit.svg',
            contentEditable: "false",
            hidden: false,
            hideDeletePopup: false,
            hideDeleteSuccessPopup: false,
            pageNum: null,
            paginationValue: 10,
            episodeName: "",
            date: "",
            mileStones: "",
            selectedMilestoneName: "",
            selectedMilestoneId: "",
            isSafari: false,
            isLoading: true,
            scheduledTime: "",
        }
        this.saveImageSrc = "./assets/images/baseline_save_white_24dp.png";
        this.editImageSrc = "./assets/images/edit2.png";
    }

    componentDidMount() {
        const browser = navigator.userAgent;
        if (browser.includes("Safari") && !browser.includes("Chrome")) {
            this.state.isSafari = true;
            this.setState(this.state);
        }
        localStorage.setItem("active-tab-of-manage-admission", "episodes");
        this.userDetails = JSON.parse(localStorage.getItem("user_details"));
        this.fetchPatientMilestones();
        this.fetchMileStones();
    }

    fetchMileStones() {
        var thisController = this;
        $.ajax({
            url: "/my-jeeva-api/fetch-milestones",
            method: "GET",
            headers: {
                Authorization: "Bearer " + localStorage.getItem("access_token"),
            },
            data: {
                treatmentId: localStorage.getItem("selectedTreatmentId")
            },
            success: function (res) {
                if (res.success === true) {
                    thisController.state.mileStones = res.result;
                    thisController.setState(thisController.state);
                }
            },
            error: function (xhr) {
                if (xhr.status == 401) {
                    window.location.href = "";
                }
            },
        });
    }




    addEmptyRow = () => {
        console.log("Adding Empty Row");
        var thisController = this;
        thisController.state.selectedMilestoneId = ""
        thisController.state.selectedMilestoneName = ""
        thisController.state.date = ""
        thisController.state.paginationValue = thisController.state.paginationValue + 5;
        if (thisController.state.pageNum != 0) {
            thisController.setState({ pageNum: 0 })
        }
        thisController.state.loadedData.unshift({
            id: "",
            milestoneName: "",
            scheduledDate: "",
            milestoneId: "",
            date: ""
        });
        thisController.state.editedId = "";
        thisController.state.disableAddButton = true;
        thisController.setState(thisController.state);

    }



    notifyEpisodeAdded() {
        toast.dismiss();
        toast(<b><img src="assets/images/done.svg" style={{ paddingRight: '0px' }}
            content="" />&nbsp;&nbsp;Episode added successfully</b>, {
            position: "top-center",
        });
    }

    notifyMsgFieldEmpty() {
        toast.dismiss();
        toast(<b><img src="assets/images/warn.svg"
            style={{ paddingRight: '0px', height: '20px', width: '20px' }} content="" />
            &nbsp;&nbsp;Please fill all the fields</b>, {
            position: "top-center"
        }, { tosatId: "empty1" });

    }

    CustomNoDataComponent = () => (
        <div style={{ padding: '20px', textAlign: 'center' }}>
            <p>There is no treatment milestone scheduled.</p>
        </div>
    );

    notifyImproperName() {
        toast.dismiss();
        toast(<b><img src="assets/images/warn.svg"
            style={{ paddingRight: '0px', height: '20px', width: '20px' }} content="" />
            &nbsp;&nbsp;Please provide a valid name</b>, {
            position: "top-center"
        });
    }
    notifyNoAgent() {
        toast.dismiss();
        toast(<b><img src="assets/images/warn.svg"
            style={{ paddingRight: '0px', height: '20px', width: '20px' }} content="" />
            &nbsp;&nbsp;No Virtual agent for this treatment </b>, {
            position: "top-center"
        });
    }
    notifyFailedLoad(response) {
        toast.dismiss();
        toast(<b style={{ color: "red" }}>{response}</b>, {
            position: "top-center",
            color: "red",
        });
    }



    notifuEpisodeUpdated() {
        toast.dismiss();
        toast(<b><img src="assets/images/done.svg" style={{ paddingRight: '0px' }}
            content="" />&nbsp;&nbsp;Episode details updated successfully</b>, {
            position: "top-center",
        });
    }

    notifyFailedToUpdate(response) {
        toast.dismiss();
        toast(<b>{response}</b>, {
            position: "top-center",
            color: "red"
        });
    }



    makeCelledit(props, e) {
        this.markAsBeingEdited(props);
    }

    parseLocalDate = (dateValue) => {
        if (!dateValue) return new Date();

        // If it's already a Date object, return it
        if (dateValue instanceof Date) return dateValue;

        // If it's a string, parse it as YYYY-MM-DD (local date)
        if (typeof dateValue === 'string') {
            const parts = dateValue.split('-');
            if (parts.length === 3) {
                return new Date(parts[0], parseInt(parts[1]) - 1, parts[2]);
            }
        }

        // If it's a number (Unix timestamp in milliseconds from backend)
        // Backend stores dates as UTC midnight, so we adjust for timezone offset
        if (typeof dateValue === 'number') {
            const date = new Date(dateValue);
            const offset = date.getTimezoneOffset() * 60 * 1000; // offset in milliseconds
            return new Date(dateValue + offset);
        }

        return new Date();
    }

    markAsBeingEdited(props) {
        this.state.scheduledTime = props.scheduledTime || "";
        this.state.editedId = props.id;
        this.state.selectedMilestoneId = props.milestoneId;
        this.state.selectedMilestoneName = props.milestoneName
        this.state.date = this.parseLocalDate(props.scheduledDate);
        var stateObj = this.state;
        this.setState(stateObj);
    }

    notifyError() {
        toast.dismiss();
        toast(<b><img src="assets/images/warn.svg" style={{ paddingRight: '0px', height: '20px', width: '20px' }}
            content="" />&nbsp;&nbsp;Oops! Error occurred.Please try again</b>, {
            position: "top-center"
        });
    }




    openDeletePopUp = (props) => {

        confirmAlert({
            title: 'Confirm to Delete',
            message: `Are you sure you want to delete ${props.milestoneName} ?`,
            buttons: [
                {
                    label: 'Yes',
                    onClick: () => this.deletePatientMilestone(props.id)
                },
                {
                    label: 'No',
                }
            ],
            overlayClassName: "confirmAlertStyle"
        });
    }


    deletePatientMilestone = (id) => {
        var deleteApiController = this

        $.ajax({
            url: "/my-jeeva-api/delete-patient-milestone/" + id,

            method: "DELETE",
            headers: {
                Authorization: "Bearer " + localStorage.getItem("access_token"),
            },
            success: function (res) {
                if (res.success === true) {
                    deleteApiController.fetchPatientMilestones();
                }
            },
            error: function (xhr) {
                if (xhr.status == 401) {
                    window.location.href = "";
                }
            },
        });
    }

    fetchPatientMilestones = () => {
        var thisController = this;
        $.ajax({
            url: "/my-jeeva-api/fetch-patient-milestone",
            method: "GET",
            headers: {
                Authorization: "Bearer " + localStorage.getItem("access_token"),
            },
            data: {
                patientAdmissionId: localStorage.getItem("patientAddmissionId")
            },
            success: function (res) {
                if (res.success === true) {
                    thisController.state.loadedData = res.result;
                    thisController.state.disableAddButton = false;
                    thisController.state.isLoading = false;
                    thisController.setState(thisController.state);
                }
            },
            error: function (xhr) {
                if (xhr.status == 401) {
                    window.location.href = "";
                }
            },
        });
    }


    refreshData = (e) => {
        // e.preventDefault();
        this.setState({
            isLoading: true,
            disabled: false,
            editedId: "-1",
            loadedData: [],

        });
        this.fetchPatientMilestones();
    };


    notifyDelete() {
        toast.dismiss();
        toast(<b><img src="assets/images/done.svg" style={{ paddingRight: '0px' }} content="" />&nbsp;&nbsp;Episode detail deleted successfully</b>, {
            position: "top-center",
        });
    }




    notifyFailedResponse(response) {
        toast.dismiss();
        toast(<b style={{ color: "red" }}>{response}</b>, {
            position: "top-center",
            color: "red"

        });
    }

    onPageChange = (e) => {
        this.setState({ pageNum: e })
    }




    caseInsensitiveSort = (field) => (rowA, rowB) => {
        var a;
        var b;
        if (field === "scheduledDate") {
            a = rowA[field] ? rowA[field] : "";
            b = rowB[field] ? rowB[field] : "";

        } else {
            a = rowA[field] ? rowA[field].toLowerCase() : '';
            b = rowB[field] ? rowB[field].toLowerCase() : '';
        }
        if (a > b) {
            return 1;
        }

        if (b > a) {
            return -1;
        }

        return 0;
    };

    handleDateChange = (date) => {
        var selectedDate = new Date(date);
        this.state.date = selectedDate;
        this.setState(this.state);
    };

    handleMilestoneTimeChange = (e) => {
        this.setState({ scheduledTime: e.target.value });
    };

    // handleDateChange = (date) => {
    //     const selectedDate = new Date(date);

    //     const formattedDate = selectedDate.toLocaleDateString('en-US', {
    //         year: 'numeric',
    //         month: '2-digit',
    //         day: '2-digit'
    //     });
    //     if (formattedDate) {
    //         this.state.date = formattedDate;
    //         this.setState(this.state);
    //     }
    // };





    // handleDropdownChange = (event) => {
    //     const selectedMilestone = JSON.parse(event.target.value);
    //     const selectedMilestoneId = selectedMilestone.id;
    //     const selectedMilestoneName = selectedMilestone.mileStoneName;

    //     console.log("selectedMilestone", selectedMilestone);

    //     this.setState({
    //         selectedMilestoneId,
    //         selectedMilestoneName,
    //     });
    // };

    handleDropdownChange = (event) => {
        const selectedMilestoneName = event.target.value;
        const selectedMilestone = this.state.mileStones.find(
            (milestone) => milestone.mileStoneName === selectedMilestoneName
        );

        this.setState({
            selectedMilestoneId: selectedMilestone ? selectedMilestone.id : "",
            selectedMilestoneName,
        });
    };


    savePatientMilestone = () => {
        var thisController = this;

        const selectedDate = new Date(thisController.state.date);
        const formattedDate = `${selectedDate.getFullYear()}-${String(selectedDate.getMonth() + 1).padStart(2, '0')}-${String(selectedDate.getDate()).padStart(2, '0')}`;

        var patientMilestoneData = {
            patientAdmissionId: localStorage.getItem("patientAddmissionId"),
            patientId: localStorage.getItem("patientId"),
            milestoneName: thisController.state.selectedMilestoneName,
            milestoneId: thisController.state.selectedMilestoneId,
            scheduledDate: formattedDate,
            scheduledTime: thisController.state.scheduledTime
        }

        $.ajax({
            url: "/my-jeeva-api/save-patient-milestone",
            method: "POST",
            headers: {
                Authorization: "Bearer " + localStorage.getItem("access_token"),
                "Content-Type": "application/json",
            },
            data: JSON.stringify(patientMilestoneData),

            success: function (res) {
                if (res.success === true) {
                    thisController.fetchPatientMilestones();
                }
            },
            error: function (xhr) {
                if (xhr.status == 401) {
                    window.location.href = "";
                }
            },
        });
    }

    updatePatientMilestone = (props) => {
        var thisController = this;

        const selectedDate = new Date(thisController.state.date);
        const formattedDate = `${selectedDate.getFullYear()}-${String(selectedDate.getMonth() + 1).padStart(2, '0')}-${String(selectedDate.getDate()).padStart(2, '0')}`;


        var patientMilestoneData = {
            id: props.id,
            patientAdmissionId: localStorage.getItem("patientAddmissionId"),
            patientId: localStorage.getItem("patientId"),
            milestoneName: thisController.state.selectedMilestoneName,
            milestoneId: thisController.state.selectedMilestoneId,
            scheduledDate: formattedDate,
            scheduledTime: thisController.state.scheduledTime
        }

        $.ajax({
            url: "/my-jeeva-api/update-patient-milestone",
            method: "PATCH",
            headers: {
                Authorization: "Bearer " + localStorage.getItem("access_token"),
                "Content-Type": "application/json",
            },
            data: JSON.stringify(patientMilestoneData),

            success: function (res) {
                if (res.success === true) {
                    thisController.state.editedId = "-1";
                    thisController.fetchPatientMilestones();
                }
            },
            error: function (xhr) {
                if (xhr.status == 401) {
                    window.location.href = "";
                }
            },
        });
    }

    render() {
        const { loadedData } = this.state;

        const milestone_column = [

            {
                name: <b>Milestone</b>,
                sortable: true,
                sortFunction: this.caseInsensitiveSort('milestoneName'),
                selector: (props) => (
                    <div name="name">
                        <div
                            className="textarea"
                            style={{
                                background: 'white',
                                height: '2.7em',
                                resize: 'none',
                                paddingLeft: '2px',
                                paddingTop: '6px',
                                width: '98%',
                                border: props.id === '' || props.id === this.state.editedId ? '1px solid #D2D4DC' : 'none',
                                borderRadius: props.id === '' ? '2px' : 'none',
                            }}
                        >
                            {props.id === this.state.editedId ? (
                                <select
                                    style={{ width: "100%" }}
                                    value={this.state.selectedMilestoneName}
                                    onChange={this.handleDropdownChange}
                                >
                                    <option value="" disabled hidden>
                                        Select a milestone
                                    </option>
                                    {this.state.mileStones &&
                                        this.state.mileStones.map((selectedMileStone, index) => (
                                            <option key={index} value={selectedMileStone.mileStoneName}>
                                                {selectedMileStone.mileStoneName}
                                            </option>
                                        ))}
                                </select>
                            ) : (
                                <span>{props.milestoneName || 'N/A'}</span>
                            )}
                        </div>
                    </div>
                ),
            },
            {
                name: <b >Date</b>,
                sortable: true,
                sortFunction: this.caseInsensitiveSort("scheduledDate"),
                selector: (props) => (
                    <div
                        style={{
                            display: "flex",
                            alignItems: "center",
                        }}
                    >
                        {props.id === this.state.editedId ? (
                            <DatePicker
                                portalId="root"
                                style={{
                                    width: "100%",
                                    // marginLeft: "70%",
                                    cursor: "pointer",
                                    fontSize: "10pt",
                                    borderBottom: "none"
                                }}
                                autoOk={true}
                                value={this.state.date}
                                placeholderText={"Please select a date"}
                                selected={this.state.date}
                                // selected={new Date(this.state.date + 'T00:00:00')}
                                onChange={this.handleDateChange}
                                dateFormat="MM/dd/yyyy"
                                popperClassName="milestone-date-picker"
                                onKeyDown={(e) => e.preventDefault()} // Prevent keyboard input
                            ></DatePicker>
                        ) : (
                            (() => {
                                const date = this.parseLocalDate(props.scheduledDate);
                                const mm = String(date.getMonth() + 1).padStart(2, "0");
                                const dd = String(date.getDate()).padStart(2, "0");
                                const yyyy = date.getFullYear();
                                return `${mm}/${dd}/${yyyy}`;
                            })()
                        )}
                    </div>
                ),
            },

            {
                name: <b>Time, 24-hour clock (Optional)</b>,
                sortable: true,
                sortFunction: this.caseInsensitiveSort("scheduledTime"),
                selector: (props) => (
                    (props.id === this.state.editedId || props.id === "") ? (
                        <input
                            type="time"
                            className="form-control col-11"
                            id={"milestoneTime" + props.id}
                            name="time"
                            placeholder="Optional"
                            value={this.state.scheduledTime}
                            style={{
                                width: "95%",
                                cursor: "pointer",
                                border: "1px solid #D2D4DC",
                                borderRadius: "4px",
                                fontSize: "10pt",
                            }}
                            onChange={this.handleMilestoneTimeChange}
                        />
                    ) : (
                        <div>{props.scheduledTime || "-"}</div>
                    )
                ),
            },

            {
                name: <b>Actions</b>,
                width: 20,
                selector: (props) => (
                    <div id="action">
                        <button style={{ backgroundColor: "#ffffff", border: "none", marginLeft: '-6px' }} >
                            <img className="img-responsive"
                                title={(props.id == "") ||
                                    (props.id == this.state.editedId) ? 'Save' : 'Edit'}
                                style={{ marginTop: '6px', backgroundColor: '#282a65', borderRadius: '5px', padding: '1px' }}
                                src={(props.id == "") ? this.saveImageSrc : ((props.id != this.state.editedId) ? this.editImageSrc : this.saveImageSrc)}
                                onClick={(e) => {
                                    (props.id == "") ?
                                        this.savePatientMilestone(props, e)
                                        :
                                        (props.id == this.state.editedId) ?
                                            this.updatePatientMilestone(props, e)

                                            : this.makeCelledit(props, e);
                                }}
                            />
                        </button>


                        <button style={{
                            backgroundColor: "#ffffff", border: "none", marginLeft: '-6px'
                        }} title="Delete">
                            <img className="img-responsive" src={"./assets/images/baseline_delete_white_24dp.png"}
                                style={{ marginTop: '6px', backgroundColor: '#282a65', borderRadius: '5px', padding: '1px' }}
                                onClick={() => (props.id) === '' ?
                                    this.fetchPatientMilestones()
                                    :
                                    this.openDeletePopUp(props)
                                }

                            /></button>
                    </div>), width: 100
            },
        ]
        return (
            <div style={{ marginRight: '1%' }} id='painDataTab'>

                <div style={{ background: "#F9F9FB", overflowY: 'scroll', overflowX: 'hidden', height: '60vh' }} >
                    <link rel="stylesheet" href="assets/css/ReactToastify.css" />
                    <link rel="stylesheet" href="assets/css/React_Table_CSS/react-table.css" />
                    <link href="assets/css/ej2-base.css" rel="stylesheet" />
                    <link href="assets/css/ej2-react-buttons.css" rel="stylesheet" />
                    <link href="assets/css/ej2-react-popups.css" rel="stylesheet" />
                    <link href="assets/css/ej2-inputs.css" rel="stylesheet" />
                    <link href="assets/css/screenResolution.css" rel="stylesheet" />
                    <link rel="shortcut icon" type="image/png" href="assets/images/bot.ico" />
                    <link rel="stylesheet" href="plugins/font-awesome/css/font-awesome.min.css" />
                    <link rel="stylesheet" href="assets/fonts/flat-icon/flaticon.css" />
                    <link rel="stylesheet" href="assets/css/adminlte.css" />
                    <link rel="stylesheet" href="assets/css/custom-style.css" />
                    <link rel="stylesheet" href="assets/css/styles.css" />
                    <link rel="stylesheet" href="assets/css/toggleButton.css" />
                    <link rel="stylesheet" href="assets/css/painDataSchedule.css" />


                    <div className={`${this.state.isSafari ? "" : "row"}`} style={{ marginLeft: '14px' }}>
                        <div className='col-sm-1'>
                        </div>
                        <div className='col-sm-8' Align='right'>

                        </div>
                        <div className="col-sm-3" style={{ marginTop: '-18px' }}>
                            <div className="d-flex flex-row-reverse pt-2">

                                <div className="p-2"
                                    style={{
                                        marginBottom: '10px',
                                        display: this.state.isSafari ? "flex" : "",
                                    }}>

                                    <button className="btn action-button"
                                        id="addMsg" title=" Add "
                                        onClick={this.state.disableAddButton ? this.notifyMsgFieldEmpty : this.addEmptyRow}>
                                        <img src="assets/images/add_white_24dp.png" />
                                    </button>
                                    <button title="Refresh" onClick={this.refreshData} type="button" className="btn action-button">
                                        <img src="./assets/images/refresh_white_24dp.png"></img></button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="row" style={{ textAlign: 'left' }}>
                        <div className="col-lg-12 ">
                            <div className="card">
                                {this.state.isLoading && (
                                    <div style={{ padding: '20px', textAlign: 'center' }}>
                                        <p>Loading ...</p>
                                    </div>
                                )}
                                {!this.state.isLoading && this.state.loadedData.length === 0 && (
                                    <div style={{ padding: '20px', textAlign: 'center' }}>
                                        <p>There is no treatment milestone scheduled. </p>
                                    </div>
                                )}
                                {!this.state.isLoading && this.state.loadedData.length > 0 &&
                                    (
                                        <DataTable
                                            data={loadedData}
                                            columns={milestone_column}
                                            defaultPageSize={5}
                                            pageSizeOptions={[5, 10, 15]}
                                            onPageChange={this.onPageChange}
                                            pagination={this.state.paginationValue}
                                            noDataComponent={<this.CustomNoDataComponent />}
                                        />)}
                            </div>
                            <ToastContainer className="Toast-at-center" />
                        </div>
                    </div>
                </div>
            </div >
        )
    }
}

export default ScheduleMileStone;


// WEBPACK FOOTER //
// src/my-jeeva/projectmgmt/ScheduleMileStone.js